import {
  getFrontendConfigLoader,
  type ConfigLoader,
  type FrontendConfigurationSchema,
} from '@doxyme/config';

export type ResolvedFrontendGraphqlUrls = {
  /** GraphQL HTTP endpoint for api-core. */
  graphqlUrl: string;
};

export function getResolvedFrontendGraphqlUrls(
  config: ConfigLoader<FrontendConfigurationSchema> = getFrontendConfigLoader(),
): ResolvedFrontendGraphqlUrls {
  const core = config.getOptional('API_CORE_GRAPHQL_URL');

  if (core === undefined || String(core).trim() === '') {
    throw new Error('API_CORE_GRAPHQL_URL is undefined or empty');
  }

  return { graphqlUrl: String(core) };
}
